import React, { useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import { HotelContext } from "../context/HotelContext";
import { getDefaultHotelPath, parseHotelFeatureNames } from "../utils/hotelNavigation";

const HotelDefaultRedirect = () => {
  const auth = useAuth();
  const { hId } = useContext(HotelContext);
  const [targetPath, setTargetPath] = useState(null);

  useEffect(() => {
    if (!hId || !auth.isAuthenticated || !auth.user?.access_token) {
      setTargetPath("/user/hotels");
      return;
    }

    let cancelled = false;

    fetch(`/api/hotels/${hId}/subscriptions/`, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + auth.user.access_token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((subData) => {
        if (cancelled) return;
        const hotelFeatures = parseHotelFeatureNames(subData);
        setTargetPath(getDefaultHotelPath(hotelFeatures));
      })
      .catch(() => {
        if (!cancelled) {
          setTargetPath("/user/hotels");
        }
      });

    return () => {
      cancelled = true;
    };
  }, [hId, auth.isAuthenticated, auth.user?.access_token]);

  if (!targetPath) {
    return null;
  }

  return <Navigate to={targetPath} replace />;
};

export default HotelDefaultRedirect;
